class NavigationService {
  constructor() {
    this.currentPageTitle = 'Main Street CRM';
  }
}

export default NavigationService;
